import { CustomerListItem } from "../customerTilesUtils";
import { atom, useAtom } from "jotai";
import { useQuery } from "@apollo/client";
import { midgardClients } from "providers/MidgardProvider";
import { ONE_SECOND_OF_MS } from "utils/timeUtils";
import { PROCESS_GROUPS_QUERY_CHEAP } from "components/DataGetter/ProcessGroupsGetter";

export const allMidgardProcessGroupsAtom = atom<{
  [ckey: string]: any;
}>({});

export function FetchAllMidgardProcessGroups({
  customersList,
}: {
  customersList: CustomerListItem[];
}) {
  return (
    <>
      {customersList.map(({ abbrevName: ckey }) => {
        return <FetchMidgardProcessGroups key={ckey} {...{ ckey }} />;
      })}
    </>
  );
}
function FetchMidgardProcessGroups({ ckey }: { ckey: string }) {
  const [, setMidgardProcessGroups] = useAtom(allMidgardProcessGroupsAtom);
  const { loading, refetch, error } = useQuery(PROCESS_GROUPS_QUERY_CHEAP, {
    client: midgardClients.get(ckey),
    variables: {},
    fetchPolicy: "cache-first",
    onError: err => {
      // refetch after a 10 second delay
      setTimeout(refetch, 10 * ONE_SECOND_OF_MS);
      console.log(`Midgard Process Groups query gone wrong. cKey: ${ckey}`);
      console.log(`${err}: retrying in 10 seconds`);
    },
    onCompleted: data => {
      if (data?.processGroups && !loading && !error) {
        setMidgardProcessGroups(prev => ({
          ...prev,
          [ckey]: data.processGroups,
        }));
      }
    },
  });
  return null;
}
